export default __webpack_public_path__ + "static/media/Hair_8_M_C5.5112d192.svg";